var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-text w-full",class:{'detail-info': _vm.isLimitText},attrs:{"title":_vm.getDetailInfo()}},[_vm._v(" "+_vm._s(_vm.getDetailInfo())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }